import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'gardenSoil',
      d: 'M-1,-2.5h0.5v0.5h-0.5zM-1.5,-2h2.5v0.5h-2.5zM-3,-1.5h1v0.5h-1zM0.5,-1.5h1.5v0.5h-1.5zM1.5,-1h0.5v0.5h-0.5zM2.5,-1h1.5v0.5h-1.5zM-4,-0.5h1v0.5h-1zM2,-0.5h2v0.5h-2zM-2.5,0h2v0.5h-2zM1,0h1.5v0.5h-1.5zM-0.5,0.5h1v0.5h-1zM1,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'leaf',
      d: 'M-2,-1.5h1.5v0.5h-1.5zM-2.5,-1h4v0.5h-4zM-2.5,-0.5h1v0.5h-1zM-0.5,-0.5h2.5v0.5h-2.5zM-0.5,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'flower',
      d: 'M-2.5,-2.5h0.5v0.5h-0.5zM-3,-2h1.5v0.5h-1.5zM-0.5,-1.5h1v0.5h-1zM2,-1.5h1v0.5h-1zM2,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'gardenFence',
      d: 'M-4.5,-2h0.5v0.5h-0.5zM-4.5,-1.5h1v0.5h-1zM-4.5,-1h2v0.5h-2zM-4.5,-0.5h0.5v0.5h-0.5zM-3,-0.5h0.5v1h-0.5zM-1.5,-0.5h1v0.5h-1zM0,0h1v0.5h-1zM0.5,0.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 74,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
